import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpHelpersService, LoadingService } from '@coin/shared/core/data-access';
import { environment } from '@coin/shared/core/util-environments';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { IncentiveAllocationEmployee } from '../../merit-shared/models/incentive-allocation-employee.model';

@Injectable({
  providedIn: 'root'
})
export class IncentiveSupportService {
  private httpClient = inject(HttpClient);
  private httpHelpersService = inject(HttpHelpersService);
  private loadingService = inject(LoadingService);

  getIncentiveAllocation(seasonId: string, employeeId: string): Observable<IncentiveAllocationEmployee> {
    this.loadingService.present();
    return this.httpClient
      .get<IncentiveAllocationEmployee>(
        `${environment.api.baseUrl}/admin/api/v2/master/seasons/incentive/partner/allocations/total/${employeeId}?meritSeasonId=${seasonId}`
      )
      .pipe(
        this.httpHelpersService.handleError('Cannot get incentive allocation'),
        finalize(() => this.loadingService.dismiss())
      );
  }
}
